import { getPaddingString, toRGBA } from "../parser/utils";
import { ALIGN_MAPPING } from "../constanst";

export default ({ data, root }) => {
  const {
    label,
    backgroundColor,
    align = "center",
    width,
    autoWidth,
    submitedRedirectUrl,
    submitedAction,
    contentBlock,
    landingPage,
    action,
    borderWidth,
    borderStyle,
    borderColor,
    borderRadius,
    labelColor,
    fontSize,
    fontWeight,
  } = data;
  const labelStyle = ["text-align:center"]
  if (fontSize) {
    labelStyle.push(`font-size:${fontSize}px`);
  }
  if (fontWeight) {
    labelStyle.push(`font-weight:${fontWeight}`);
  }
  if (labelColor) {
    labelStyle.push(`color:${toRGBA(labelColor)}`);
  }
  let redirectUrl =  "";
  if (submitedAction === "redirectUrl") {
    redirectUrl = submitedRedirectUrl;
  } else if (submitedAction === "landing") {
    redirectUrl = landingPage;
  }
  
  return `
    <div
      class="rip-field-group"
      style="
        display: flex;
        width: 100%;
        justify-content: ${ALIGN_MAPPING[align]};
      "
    >
      <div
        class="rip-mm-submit-btn ${action}"
        data-redirect="${redirectUrl}"
        data-content="${contentBlock}"
        data-action="${submitedAction}"
        style="
          ${getPaddingString(data)}
          align-items: center;
          cursor: pointer;
          width:${autoWidth ? "auto" : width + "%"};
          background-color: ${toRGBA(backgroundColor)};
          border-width: ${borderWidth}px;
          border-style: ${borderStyle};
          border-color: ${toRGBA(borderColor)};
          border-radius: ${borderRadius}px;
          color: ${toRGBA(labelColor)};
        "
      >
        <div style="${labelStyle.join(";")}">${label}</div>
      </div>
    </div>
  `;
};
